/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import HomeBanner from "../Component/Home/HomeBanner";
import DailyOffer from "../Component/Home/DailyOffer";
import Reservation from "../Component/Home/Reservation";
import PopularFood from "../Component/Home/PopularFood";
import BestSelling from "../Component/Home/BestSelling";
import EasyToOrder from "../Component/Home/EasyToOrder";
import Testimonial from "../Component/Home/Testimonial";
import States from "../Component/Home/States";
import Blog from "../Component/Home/Blog";
import Layout from "../Component/Layout/Layout";
import { axiosInstance } from "../Component/utils/axiosInstance";
export default function Home() {
  const [category, setCategory] = useState([]);
  const [filterCategory, setFilterCategory] = useState([]);

  const allCategory = async () => {
    try {
      await axiosInstance.get("user/category").then((response) => {
        if (response.data.status === true) {
          setCategory(response?.data?.categories);
        }
      });
    } catch (error) { }
  };
  useEffect(() => {
    allCategory();
  }, []);

  return (
    <>
      <Layout>
        <HomeBanner
          setFilterCategory={setFilterCategory}
          categories={category}
        />

        <PopularFood
          category={category}
          setFilterCategory={setFilterCategory}
          filterCategory={filterCategory}
        />
        {/* <DailyOffer /> */}
        {/* <Reservation /> */}
        {/* <BestSelling /> */}
        <div className="pb-4">
          <EasyToOrder />
        </div>
        {/* <Testimonial /> */}
        {/* <States /> */}
        {/* <Blog /> */}
      </Layout>
    </>
  );
}
